import * as React from 'react'
import { ISystemBase } from '../../library/types/ISystemBase';
import { IDynamicList } from '../../library/types/IDynamicList'
import SystemDropDown from './SystemDropDown';
interface ISystemLookUpDropDown {
    lookupName: string,
    ShowAllergy: boolean
}
/* abhishek singh for this time being i added one parameter for passing parameter as boolean  sandeep sir will make as sql paramater in sp*/
export default (props: ISystemLookUpDropDown & IDynamicList & ISystemBase) =>
    <SystemDropDown {...props} isCached={true} dropDownType="Lookup" dataSource={`${props.lookupName}`} dataItemKey="DataValue" textField="DataText" />

export const AllergyDropDown = (props: ISystemLookUpDropDown & IDynamicList & ISystemBase) => <SystemDropDown {...props} isCached={true} dataSource={`/lookup/AllergyLookup/${props.lookupName + '/' + (props.ShowAllergy == undefined ? false : props.ShowAllergy)}`} dataItemKey="DataValue" textField="DataText" />
